// extracted by mini-css-extract-plugin
export var benefitInfo = "ordrer-summary-module--benefit-info--ba951";
export var container = "ordrer-summary-module--container--7f6d7";
export var items = "ordrer-summary-module--items--188e3";
export var list = "ordrer-summary-module--list--39e50";
export var nameHolder = "ordrer-summary-module--name-holder--4480f";
export var orderHeader = "ordrer-summary-module--order-header--0a0b4";
export var recurringPaymentInfo = "ordrer-summary-module--recurring-payment-info--3451c";
export var summary = "ordrer-summary-module--summary--72e7e";
export var summaryItem = "ordrer-summary-module--summary-item--7acd2";
export var summaryPrices = "ordrer-summary-module--summary-prices--17ea5";